var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"buttonBox"},[_c('button',{on:{"click":_vm.onPush}},[_vm._v(_vm._s(_vm.name))]),_c('img',{attrs:{"src":_vm.buttonState ? _vm.onImgSrc : _vm.offImgSrc}})])}
var staticRenderFns = []

export { render, staticRenderFns }